export class Contract{
  constructor(
    public ID:number,
    public Customer_ID:number,
    public Service_ID:number,
    private status:string,
    private assign:boolean,
    private day:string,
    private period:string,
    private term:number,
    public initial_investment:number,
    public cost:number,
    public Employee_ID: number,
    public ea:number,
    public folio:string,
  )
  {

  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/models/contract.model.ts